import api from "./api";

const ENDPOINT_BASE = '/forecast';

function saveForecast(payload) {
    return api.post(`${ENDPOINT_BASE}`, payload);
}

function getAll(params) {
    return api.get(`${ENDPOINT_BASE}/itens`, { params });
}

function listImportacoes(params) {
    return api.get(`${ENDPOINT_BASE}`, { params });
}

function getOpcoesFiltro(params) {
    return api.get(`${ENDPOINT_BASE}/acompanhamento/opcoes-filtro`, { params });
}

function getAcompanhamentoPlanejado(params) {
    return api.get(`${ENDPOINT_BASE}/acompanhamento/planejado`, { params });
}

function getResultadoAcompanhamento(params) {
    return api.get(`${ENDPOINT_BASE}/acompanhamento/fluxo-caixa`, { params });
}

const ForecastApiService = {
    saveForecast,
    getAll,
    listImportacoes,
    getOpcoesFiltro,
    getAcompanhamentoPlanejado,
    getResultadoAcompanhamento,
};

export default ForecastApiService;
